module.exports = __webpack_public_path__ + "img/creditpayIcon.362d7c4c.jpg";